import React from 'react';
import "./largescreen.css";
import { NavLink } from 'react-router-dom';
import NAV_LINKS, { isExact } from '../../../../Utils/navLinks';

const LargeScreen = () => {
  return (
    <div className="links fcc">
      {
        NAV_LINKS.map(({ to, label }) => (
          <NavLink className="link" to={to} end={isExact(to)} key={to}>
            {label}
            <span className="underline"></span>
          </NavLink>
        ))
      }
    </div>
  )
}

export default LargeScreen
